/* Lalacorn storefront translator: translates theme text that Shopify Translate & Adapt cannot reach. Loaded only on non-English pages. */
(function () {
  var D = window.LC_I18N;
  if (!D || !D.d) return;
  var dict = D.d, P = D.p || {}, loc = D.l || document.documentElement.lang || 'en';
  var has = Object.prototype.hasOwnProperty;
  var XL = (D.x || []).map(function (r) { return [new RegExp(r[0]), r[1]]; });
  var SF = (D.s || []).map(function (r) { return [new RegExp(r[0], 'g'), r[1]]; });
  function esc(s) { return s.replace(/[.*+?^$\{\}()|[\]\\]/g, '\\$&'); }
  var fragList = (D.f || []).slice();
  Object.keys(dict).forEach(function (k) { if (k.length >= 12 && k.indexOf(' ') > 0 && fragList.indexOf(k) < 0) fragList.push(k); });
  fragList = fragList.filter(function (k) { return k && dict[k] !== k; }).sort(function (a, b) { return b.length - a.length; });
  var bigRe = fragList.length ? new RegExp(fragList.map(esc).join('|'), 'g') : null;
  function isL(ch) { return !!ch && /[A-Za-z]/.test(ch); }
  var MONTHS = { January: 0, February: 1, March: 2, April: 3, May: 4, June: 5, July: 6, August: 7, September: 8, October: 9, November: 10, December: 11 };
  function tr(s) {
    if (typeof s !== 'string') return null;
    var t = s.replace(/\s+/g, ' ').trim();
    if (!t || !/[A-Za-z]/.test(t)) return null;
    if (has.call(dict, t)) return dict[t];
    var m;
    if ((m = t.match(/^([:·\-–(\s]+)?(.*?)([:·\-–)\s.]+)?$/)) && (m[1] || m[3]) && has.call(dict, m[2])) return (m[1] || '') + dict[m[2]] + (m[3] || '');
    if (P.addmore && (m = t.match(/^Add (\d+) more → (.+) each$/))) return P.addmore.replace('$1', m[1]).replace('$2', m[2]);
    if (P.from && (m = t.match(/^from\s+(\S*\d.*)$/i))) return P.from.replace('$1', m[1]);
    if (P.addto && (m = t.match(/^Add (.+) to cart$/))) return P.addto.replace('$1', m[1]);
    if (P.choosefor && (m = t.match(/^Choose option for (.+)$/))) return P.choosefor.replace('$1', m[1]);
    if (P.choose && (m = t.match(/^Choose (?!an option$)(.+)$/))) return P.choose.replace('$1', m[1]);
    var xo = t; for (var xi = 0; xi < XL.length; xi++) xo = xo.replace(XL[xi][0], XL[xi][1]); if (xo !== t) return xo;
    if (t.indexOf(' / ') > 0) { var ps = t.split(' / '); if (ps.every(function (x) { return has.call(dict, x); })) return ps.map(function (x) { return dict[x]; }).join(' / '); }
    if (P.step && (m = t.match(/^Step (\d+) Video$/))) return P.step.replace('$1', m[1]);
    if (P.video && (m = t.match(/^Video (\d+)$/))) return P.video.replace('$1', m[1]);
    if (P.stars && (m = t.match(/^(\d) stars?$/))) return P.stars.replace('$1', m[1]);
    if (P.more && (m = t.match(/^Show (\d+) more$/))) return P.more.replace('$1', m[1]);
    if (P.outof && (m = t.match(/^([\d.,]+) out of 5 stars$/))) return P.outof.replace('$1', m[1]);
    if (P.rev && (m = t.match(/^Reviewed on ([A-Z][a-z]+) (\d{1,2}), (\d{4})$/)) && has.call(MONTHS, m[1])) {
      try { return P.rev + new Date(+m[3], MONTHS[m[1]], +m[2]).toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) {}
    }
    var out = t, changed = false;
    if (bigRe) {
      bigRe.lastIndex = 0;
      out = t.replace(bigRe, function (mt, off, str) {
        if (/^[A-Za-z]/.test(mt) && isL(str.charAt(off - 1))) return mt;
        if (/[A-Za-z]$/.test(mt) && isL(str.charAt(off + mt.length))) return mt;
        changed = true;
        return dict[mt];
      });
    }
    if (P.dhm && /\b\d+d \d+h \d+m\b/.test(out)) { out = out.replace(/\b(\d+)d (\d+)h (\d+)m\b/g, function (_, d, h, mi) { return P.dhm.replace('$1', d).replace('$2', h).replace('$3', mi); }); changed = true; }
    return changed ? out : null;
  }
  window.LC_T = function (s) { var r = tr(s); return r == null ? s : r; };

  var seen = new WeakMap();
  function doText(n) {
    var v = n.nodeValue;
    if (seen.get(n) === v) return;
    var r = tr(v);
    if (r != null) {
      var op = n.parentNode;
      if (op && op.tagName === 'OPTION' && !op.hasAttribute('value')) op.setAttribute('value', op.value);
      var nv = v.match(/^\s*/)[0] + r + v.match(/\s*$/)[0];
      if (nv !== v) n.nodeValue = nv;
      seen.set(n, nv);
    } else {
      seen.set(n, v);
    }
  }
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var LINK_SKIP = /^\/(cdn|apps|services|tools|a\/|checkouts?|localization|cart\/(add|change|clear|update)|(de|fr|es|it|nl|pt-PT|pt|en)(\/|$|\?|#))/;
  function fixLink(e) {
    if (!ROOT) return;
    var at = e.tagName === 'A' ? 'href' : (e.tagName === 'FORM' ? 'action' : null);
    if (!at) return;
    var h = e.getAttribute(at);
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/' || LINK_SKIP.test(h)) return;
    if (e.tagName === 'FORM' && !/^\/(search|contact|cart)(\/|$|\?)/.test(h)) return;
    e.setAttribute(at, ROOT + h);
  }
  var ATTRS = ['placeholder', 'aria-label', 'title'];
  function doEl(e) {
    fixLink(e);
    if (e.tagName === 'IMG' || e.tagName === 'PICTURE' || e.tagName === 'SOURCE') return;
    if (e.matches && e.matches('.lc-sw, [class*="swatch"], [data-value], [data-option-value], [data-color]')) return;
    for (var k = 0; k < ATTRS.length; k++) {
      var a = ATTRS[k];
      if (e.hasAttribute(a)) {
        var v = e.getAttribute(a), r = tr(v);
        if (r != null && r !== v) e.setAttribute(a, r);
      }
    }
    if (e.tagName === 'INPUT' && /^(submit|button)$/i.test(e.type) && e.value) {
      var r2 = tr(e.value);
      if (r2 != null && r2 !== e.value) e.value = r2;
    }
  }
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1, CODE: 1, SVG: 1, svg: 1 };
  function rejected(e) { return SKIP[e.tagName] || e.isContentEditable || e.hasAttribute('data-lc-notr'); }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      var p = root.parentNode;
      if (p && p.nodeType === 1 && !rejected(p) && !(p.closest && p.closest('[data-lc-notr]'))) doText(root);
      return;
    }
    if (root.nodeType !== 1 || rejected(root) || (root.closest && root.closest('[data-lc-notr]'))) return;
    doEl(root);
    var w = document.createTreeWalker(root, 5, {
      acceptNode: function (x) { return x.nodeType === 1 && rejected(x) ? 2 : 1; }
    });
    var x;
    while ((x = w.nextNode())) { if (x.nodeType === 3) doText(x); else doEl(x); }
  }

  /* size helper results are built from English sentence parts: translate the whole paragraph before the text pass */
  var sfSeen = new WeakMap();
  function sfAll() {
    if (!SF.length) return;
    var els = document.querySelectorAll('.lc-sizefit__result p, .lc-sizefit__select');
    for (var i = 0; i < els.length; i++) {
      var e = els[i], btn = e.tagName === 'BUTTON', h = btn ? e.textContent : e.innerHTML;
      if (sfSeen.get(e) === h) continue;
      var o = h;
      for (var k = 0; k < SF.length; k++) { SF[k][0].lastIndex = 0; o = o.replace(SF[k][0], SF[k][1]); }
      if (o !== h) { if (btn) e.textContent = o; else e.innerHTML = o; }
      sfSeen.set(e, btn ? e.textContent : e.innerHTML);
    }
  }
  function start() {
    try { sfAll(); } catch (e) {}
    walk(document.body);

  var queue = [], attrQueue = [], scheduled = false;
  function flush() {
    scheduled = false;
    try { sfAll(); } catch (e) {}
    var a = queue, b = attrQueue;
    queue = []; attrQueue = [];
    for (var i = 0; i < a.length; i++) walk(a[i]);
    for (var j = 0; j < b.length; j++) if (b[j].isConnected) doEl(b[j]);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(flush);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.type === 'childList') { for (var j = 0; j < m.addedNodes.length; j++) queue.push(m.addedNodes[j]); }
        else if (m.type === 'characterData') queue.push(m.target);
        else if (m.type === 'attributes' && m.target.nodeType === 1) attrQueue.push(m.target);
      }
      schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder', 'aria-label', 'title', 'value', 'href'] });
  }

  }
  function later() { setTimeout(start, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();

  ['alert', 'confirm'].forEach(function (fn) {
    var orig = window[fn];
    if (typeof orig !== 'function') return;
    window[fn] = function (msg) { return orig.call(window, typeof msg === 'string' ? (tr(msg) || msg) : msg); };
  });
})();
